import { createServerFn } from "@tanstack/react-start";

export type LatestPostDTO = {
  id: string;
  slug: string;
  title: string;
  excerpt: string | null;
  content: string;
  cover_image_url: string | null;
  published_at: string | null;
  category: { name: string; slug: string } | null;
} | null;

export const getLatestPost = createServerFn({ method: "GET" }).handler(
  async (): Promise<LatestPostDTO> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data } = await supabaseAdmin
      .from("posts")
      .select(
        "id, slug, title, excerpt, content, cover_image_url, published_at, category:categories!posts_category_id_fkey(name, slug)",
      )
      .eq("status", "published")
      .order("published_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    return (data as LatestPostDTO) ?? null;
  },
);